<template>
    <div class="row">
        <div class="col-12">
            <div class="row">

                <div class="col-4 mb-2">
                    <label class="control-label" v-bind:for="`${idPrefix}name`">
                        {{resource('DivisionMiscellaneousFieldEditModel_Name_DisplayName')}}
                    </label>
                </div>

                <div class="col-8 mb-2">
                    <input v-bind:id="`${idPrefix}name`" class="form-control" type="text" v-model="field.name" maxlength="50">
                    <required-error-message
                        v-if="nameIsMissing"
                        v-bind:field-name="resource('DivisionMiscellaneousFieldEditModel_Name_DisplayName')"
                    >
                    </required-error-message>
                </div>

                <div class="col-4 mb-2">
                    <label class="control-label" v-bind:for="`${idPrefix}label`" maxlength="150">
                        {{resource('DivisionMiscellaneousFieldEditModel_Label_DisplayName')}}
                    </label>
                </div>

                <div class="col-8 mb-2">
                    <input v-bind:id="`${idPrefix}label`" class="form-control" type="text" v-model="field.label">
                </div>

                <div class="col-4 mb-2">
                    <label class="control-label" v-bind:for="`${idPrefix}type`">
                        {{resource('DivisionMiscellaneousFieldEditModel_ValueType_DisplayName')}}
                    </label>
                </div>

                <div class="col-8 mb-2">
                    <dropdown
                        v-bind:options="sortedTypeDropdownOptions"
                        text-field="text"
                        value-field="value"
                        v-model="field.valueType"

                        v-bind:id="`${idPrefix}type`"
                    >
                    </dropdown>
                    <required-error-message
                        v-if="valueTypeIsMissing"
                        v-bind:field-name="resource('DivisionMiscellaneousFieldEditModel_ValueType_DisplayName')"
                    >
                    </required-error-message>
                </div>

                <div class="col-4 mb-2">
                    <label class="control-label" v-bind:for="`${idPrefix}jsonPath`" maxlength="150">
                        {{resource('DivisionMiscellaneousFieldEditModel_JsonPath_DisplayName')}}
                    </label>
                </div>

                <div class="col-8 mb-2">
                    <input v-bind:id="`${idPrefix}jsonPath`" class="form-control" type="text" v-model="field.jsonPath">

                    <required-error-message 
                        v-if="jsonPathIsMissing" 
                        v-bind:field-name="resource('DivisionMiscellaneousFieldEditModel_JsonPath_DisplayName')"
                    >
                    </required-error-message>
                    <br v-if="jsonPathIsMissing"/>
                    <error-message 
                        v-if="!jsonPathIsValid" 
                        v-bind:field-name="resource('DivisionMiscellaneousFieldEditModel_JsonPath_DisplayName')" 
                        v-bind:message="resource('DivisionMiscellaneousFieldEditModel_JsonPath_InvalidPath_ErrorMessage')"
                    >    
                    </error-message>
                </div>

                <div class="col-4 mb-2">
                    <label class="control-label" v-bind:for="`${idPrefix}sortOrder`">
                        {{resource('DivisionMiscellaneousFieldEditModel_SortOrder_DisplayName')}}
                    </label>
                </div>

                <div class="col-8 mb-2">
                    <input v-bind:id="`${idPrefix}sortOrder`" class="form-control" type="number" v-model.number="field.sortOrder">
                    <required-error-message
                            v-if="sortOrderIsMissing"
                            v-bind:field-name="resource('DivisionMiscellaneousFieldEditModel_SortOrder_DisplayName')"
                    >
                    </required-error-message>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import settingsDivisionMiscellaneousApi from '../../../Api/settings-division-miscellaneous';
    import growler from "../../../Util/growler";
    import _ from 'lodash'
    
    import resourceMixin from '../../../Util/Mixins/resources'
    
    import Dropdown from "../../../Components/FormControls/Dropdown.vue";
    import RequiredErrorMessage from "../../../Components/Errors/RequiredErrorMessage.vue";
    import ErrorMessage from "../../../Components/Errors/ErrorMessage.vue";
    
    export default {
        name: "miscellaneous-category-field",
        components: {RequiredErrorMessage, ErrorMessage, Dropdown},
        mixins: [resourceMixin],
        created(){
            const vm = this;
            
            settingsDivisionMiscellaneousApi.getTypeDropdownOptions().then(
                options => vm.typeDropdownOptions = options,
                err => growler.bootstrapDanger(err.join('\n'))
            );
        },
        data: () => ({
            typeDropdownOptions: [],
            validationErrors: {}
        }),
        computed: {
            idPrefix(){
                return `${this.field.id}_`;
            },
            sortedTypeDropdownOptions(){
                return _.sortBy(this.typeDropdownOptions, 'text');
            },
            nameIsMissing(){
                return !this.field.name;
            },
            valueTypeIsMissing(){
                return this.field.valueType === undefined;
            },
            sortOrderIsMissing(){
                return this.field.sortOrder === undefined;
            },
            jsonPathIsMissing(){
                return !this.field.jsonPath;
            },
            jsonPathIsValid(){
                //value
                //root.value
                return this.field.jsonPath && /^(\w+\.?)+[^.]$/.test(this.field.jsonPath);
            }
        },
        props: {
            field: {
                type: Object,
                required: true
            }
        }
    }
</script>